module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('urs-input', {
    ref: "input",
    class: _vm.newUp ? _vm.newup_clazz : _vm.old_clazz,
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "del_icon_clazz": _vm.del_icon_clazz
    },
    on: {
      "focus": _vm.onFocus
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newUp),
      expression: "!newUp"
    }],
    staticClass: "u-ic",
    on: {
      "click": _vm.onTogle
    },
    slot: "button"
  }, [_c('em', [_vm._v("+" + _vm._s(_vm.selected.code))]), _c('i', {
    staticClass: "btn"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "m-mask",
    on: {
      "click": _vm.onChooseC
    }
  }, [_c('div', {
    ref: "countryContainer",
    staticClass: "m-pop-ic"
  }, [_c('ul', {
    staticClass: "u-country"
  }, [_c('li', [_c('i', {
    staticClass: "tlt"
  }, [_vm._v("常用地区")])]), _vm._v(" "), _vm._l((_vm.common), function(o) {
    return _c('li', [_c('i', {
      attrs: {
        "data-code": o.num
      }
    }, [_c('em', {
      attrs: {
        "data-code": o.num
      }
    }, [_vm._v("+" + _vm._s(o.num))]), _vm._v(_vm._s(o.cnm))])])
  }), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tlt"
  }, [_vm._v("其他地区")])]), _vm._v(" "), _vm._l((_vm.other), function(o) {
    return _c('li', [_c('i', {
      attrs: {
        "data-code": o.num
      }
    }, [_c('em', {
      attrs: {
        "data-code": o.num
      }
    }, [_vm._v("+" + _vm._s(o.num))]), _vm._v(_vm._s(o.cnm))])])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0568a80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MbInput.vue
// module id = 524
// module chunks = 1